<template>
  <div class="d-flex align-items-center">
    <div v-if="saving === true">Saving</div>
    <div v-if="showMsg === true">Search saved</div>
    <b-button variant="link" class="save-search-btn m-2" @click="saveSearch()">
      Save this search <span class="small"><b-icon icon="bookmark-plus"></b-icon></span>
    </b-button>
    <router-link
      v-if="logged === true"
      class="saved-searches btn btn-link m-2"
      :to="{
        path: 'saved-searches',
      }"
      aria-label="View saved searches"
    >
      View saved searches
      <span class="small"><b-icon icon="bookmark-plus-fill"></b-icon></span>
    </router-link>
    <b-modal ref="save-search-login">
      <span v-if="logged === false">
        <a href="/login" aria-label="Link to login form" itemprop="url">Login</a>
        or
        <a href="/register" aria-label="Link to registration form" itemprop="url">register</a>
        to save searches and create favourite lists.
      </span>
    </b-modal>
  </div>
</template>
<script>
import toast from '@/services/toast'
import { SaveSearchCall } from '@/common/api.service'
export default {
  name: 'SaveSearch',
  props: {
    selectedFilters: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      saving: false,
      showMsg: false,
      lozenges: {},
      conciseSelectedFilters: [],
    }
  },
  computed: {
    selectedFiltersShort() {
      let selected = []
      this.selectedFilters.forEach((filter) => {
        selected.push({ id: filter.selected, paramId: filter.paramId, selected: filter.selected })
      })
      return selected
    },
    logged() {
      return document.body.classList.contains('logged-in')
    },
    searchUrl() {
      return this.$route.query
    },
  },
  watch: {
    selectedFilters: {
      deep: true,
      handler() {
        this.lozenges = document.getElementById('selected-filters')
        this.setConcise()
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.lozenges = document.getElementById('selected-filters')
          this.setConcise()
        })
      })
    })
  },
  methods: {
    setConcise() {
      let selected = []
      if (this.lozenges && this.lozenges.childNodes) {
        let nodeArray = Array.prototype.slice.call(this.lozenges.childNodes)
        nodeArray.forEach(function (currentValue) {
          selected.push(currentValue.textContent)
        })
      }
      return (this.conciseSelectedFilters = selected)
    },
    async saveSearch() {
      if (this.logged === false) {
        this.$refs['save-search-login'].show()
      }
      if (this.logged === true) {
        if (this.saving === false) {
          this.saving = true
          const data = await SaveSearchCall.post({
            req_id: 'save_user_search',
            search_settings: JSON.stringify(this.searchUrl),
            lozenges: JSON.stringify(this.selectedFiltersShort),
          })
          if (data.data.last_error == '') {
            toast.success('Search saved')
          } else {
            toast.error('Something went wrong')
          }
          this.saving = false
          return data
        }
        this.saving = false
        return []
      }
    },
  },
}
</script>
